import { render, staticRenderFns } from "./CompanyQuotes.vue?vue&type=template&id=3f1fb320&scoped=true"
import script from "./CompanyQuotes.vue?vue&type=script&lang=js"
export * from "./CompanyQuotes.vue?vue&type=script&lang=js"
import style0 from "./CompanyQuotes.vue?vue&type=style&index=0&id=3f1fb320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1fb320",
  null
  
)

export default component.exports